var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterAllEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 14,
    height: 3,
    fill: "#CCCFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 15H10V16C10 19.3137 12.6863 22 16 22C19.3137 22 22 19.3137 22 16V15ZM16 16C16.8284 16 17.5 16.6716 17.5 17.5C17.5 18.3284 16.8284 19 16 19C15.1716 19 14.5 18.3284 14.5 17.5C14.5 16.6716 15.1716 16 16 16Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterAllEvent);
export default __webpack_public_path__ + "static/media/icon-filter-all-event.4783afefc62cc807262122b949f66d10.svg";
export { ForwardRef as ReactComponent };